import _ from 'lodash';
import {ProductMetaDataAction} from '../actions/ProductMetaDataActions';
import {ReducerActionAttributes} from './RootReducer';
import {sortAttributesAlphabetically} from '~/lib/product';

export interface ProductMetaDataState {
    brandOptions: string[];
    effectAttributesOptions: string[];
    flavorAttributesOptions: string[];
    generalAttributesOptions: string[];
    ingredientAttributesOptions: string[];
    internalAttributesOptions: string[];
    officialBrandOptions: string[];
}

const DEFAULT_STATE = {
    brandOptions: [],
    effectAttributesOptions: [],
    flavorAttributesOptions: [],
    generalAttributesOptions: [],
    ingredientAttributesOptions: [],
    internalAttributesOptions: [],
    officialBrandOptions: [],
};

const {
    CLEAR_PRODUCT_META_DATA_STATE,
    GET_OFFICIAL_BRANDS_FROM_BRANDTREEZ,
    UPDATE_CATALOG_ATTRIBUTES,
} = ProductMetaDataAction;

export const ProductMetaDataReducer = (
    state = DEFAULT_STATE,
    action: ReducerActionAttributes<ProductMetaDataAction, any>
) => {
    const {type: typeOfAction, value} = action;

    switch (typeOfAction) {
        case CLEAR_PRODUCT_META_DATA_STATE:
            return DEFAULT_STATE;
        case UPDATE_CATALOG_ATTRIBUTES:
            const {effect, flavor, general, internal, ingredient, brandName} = value;

            const brandOptions = sortAttributesAlphabetically(brandName);
            const flavorAttributesOptions = sortAttributesAlphabetically(flavor);
            const effectAttributesOptions = sortAttributesAlphabetically(effect);
            const generalAttributesOptions = sortAttributesAlphabetically(general);
            const ingredientAttributesOptions = sortAttributesAlphabetically(ingredient);
            const internalAttributesOptions = sortAttributesAlphabetically(internal);

            return {
                ...state,
                brandOptions,
                flavorAttributesOptions,
                effectAttributesOptions,
                generalAttributesOptions,
                internalAttributesOptions,
                ingredientAttributesOptions,
                productMetaDataUpToDate: true,
            };
        case GET_OFFICIAL_BRANDS_FROM_BRANDTREEZ:
            return {
                ...state,
                officialBrandOptions: value,
            };
        default:
            return state;
    }
};

export default ProductMetaDataReducer;
